import { useEffect } from "react";
import { useBoolean } from "@chakra-ui/react";

export const useDelayedSetState = (shouldSetState: boolean, delay: number) => {
    const [state, setState] = useBoolean(true);

    useEffect(() => {
        let timerId: ReturnType<typeof setTimeout>;
        if (shouldSetState) {
            setState.on();
        } else {
            timerId = setTimeout(() => {
                setState.off();
            }, delay);
        }

        return () => {
            clearTimeout(timerId);
        };
    }, [delay, setState, shouldSetState]);

    return state;
};
